import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Card, CardContent } from '../components/ui/Card';
import { SEO } from '../utils/seo';
export function MembresCAPage() {
  const members = [{
    name: 'ABDELHAQ CHAHLI',
    role: 'PRESIDENT',
    image: 'https://cdn.magicpatterns.com/uploads/mfXKzUHPvMbQSAEqHnxBqC/chahli.png'
  }, {
    name: 'CHAFIK MAHFOUD FILALI',
    role: "PRESIDENT D'HONNEUR",
    image: 'https://cdn.magicpatterns.com/uploads/8xuioYeabbCjg2q5LNLiWC/mahfoud_filali.jpg'
  }, {
    name: 'MOHAMED AMINE BOUSLIKHANE',
    role: 'VICE PRESIDENT',
    image: 'https://cdn.magicpatterns.com/uploads/3f9ZTNMurjbBf8PU5Aq3YV/amine_bouslikhane.jpg'
  }, {
    name: 'ZAKARIA EL OUATI',
    role: 'SECRETAIRE GENERAL',
    image: 'https://cdn.magicpatterns.com/uploads/9s4nTctZuhzr36mRcxD6Az/el_ouati.jpg'
  }, {
    name: 'HICHAM SOUIRI',
    role: 'SECRETAIRE GENERAL ADJOINT',
    image: 'https://cdn.magicpatterns.com/uploads/ur2D4Veuj1HhKZS7usKxst/hicham_souiri.png'
  }, {
    name: 'FAIÇAL AMRIT',
    role: 'TRESORIER GENERAL',
    image: 'https://cdn.magicpatterns.com/uploads/5LA2z7DN3cEL3uF2jFweob/faical_amri.png'
  }, {
    name: 'MOURAD EL MELLIANI',
    role: 'TRESORIER GENERAL ADJOINT',
    image: 'https://cdn.magicpatterns.com/uploads/q95giHRLHGN3cGcJGZFcDT/mourad_el_mellliani.jpg'
  }, {
    name: 'FATIMA-ZOHRA TABITA',
    role: 'ASSESSEUR',
    image: 'https://cdn.magicpatterns.com/uploads/2zfnk1GudJAsPXPBsefYFY/fatima_zohra_tabit.png'
  }, {
    name: 'FRANCIS DESJARDINS',
    role: 'ASSESSEUR',
    image: 'https://cdn.magicpatterns.com/uploads/car9t6MqnFVMAnNa6v7iKU/francis_desjardins.jpg'
  }, {
    name: 'MOHAMED ALI BOUHJRA',
    role: 'ASSESSEUR',
    image: 'https://cdn.magicpatterns.com/uploads/c7tyjFPp5xgAjx1JEioCbG/Mohamed_Ali_Bouhjra.jpg'
  }];
  const getInitials = (name: string) => {
    return name.split(' ').map(n => n[0]).join('').slice(0, 2);
  };
  return <div className="min-h-screen bg-white" data-id="element-488">
      <SEO title="Membres du Bureau Exécutif" description="Découvrez les membres du bureau exécutif de l'ARIH Agadir Souss Massa - Président, Vice-président, Secrétaire général et l'équipe dirigeante" keywords="ARIH leadership, bureau exécutif ARIH, membres CA Agadir, direction ARIH" data-id="element-489" />
      <Navbar data-id="element-490" />

      {/* Hero */}
      <section className="bg-arih-blue py-24 md:py-32" data-id="element-491">
        <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-492">
          <h1 className="text-[48px] md:text-[60px] font-semibold text-white leading-tight mb-6" data-id="element-493">
            Membres du Bureau Exécutif
          </h1>
          <p className="text-[20px] text-white/90 leading-[32px] max-w-3xl mx-auto" data-id="element-494">
            Les membres du bureau exécutif de l'Association Régionale de
            l'Industrie Hôtelière Agadir Souss-Massa
          </p>
        </div>
      </section>

      {/* Members Grid */}
      <section className="bg-arih-light-bg py-[120px]" data-id="element-495">
        <div className="container mx-auto px-4 md:px-8" data-id="element-496">
          <h2 className="text-[36px] md:text-[40px] font-bold text-arih-dark text-center mb-16" data-id="element-497">
            Leadership
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-498">
            {members.map((member, index) => <Card key={index} className="bg-white rounded-xl shadow-sm border-0" data-id="element-499">
                <CardContent className="p-8 text-center" data-id="element-500">
                  {member.image ? <img src={member.image} alt={member.name} className="w-32 h-32 rounded-full object-cover mx-auto mb-4 border-4 border-gray-100" data-id="element-501" /> : <div className="w-32 h-32 rounded-full bg-arih-blue text-white flex items-center justify-center text-[24px] font-bold mx-auto mb-4" data-id="element-502">
                      {getInitials(member.name)}
                    </div>}
                  <h3 className="text-[20px] font-bold text-arih-dark mb-2" data-id="element-503">
                    {member.name}
                  </h3>
                  <p className="text-[14px] font-semibold text-arih-blue uppercase tracking-wider" data-id="element-504">
                    {member.role}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-505" />
    </div>;
}